<template>
	<ul class="thrive__form__item__errors">
		<li v-for="(message, index) in errors" v-html="message"></li>
	</ul>
</template>
<script>
	export default {
		props: ['fieldName'],
		computed: {
			errors() {
				return this.$store.getters['formErrors/getErrors'](this.fieldName);
			}
		},
	}
</script>


// WEBPACK FOOTER //
// resources/js/components/form-error.vue